import { type AiSessionRequest } from '@/api/ai';

const DEFAULT_PROVIDER = 'openrouter';

function readEnv(name: string): string | undefined {
  const value = import.meta.env[name];
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

export function buildDefaultSessionRequest(): AiSessionRequest {
  const provider = readEnv('VITE_AI_PROVIDER') ?? DEFAULT_PROVIDER;
  const model = readEnv('VITE_AI_MODEL');

  return {
    session_type: 'general',
    provider,
    ...(model ? { model } : {}),
  };
}
